const ArrowRight = ({ width, height = "h-auto" }) => {
    return (
        <div className={`arrow-right ${width} ${height}`}>
            <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
  >
    <path
      stroke="#231F20"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M2.813 9h12.375M10.125 3.938 15.188 9l-5.063 5.063"
    ></path>
  </svg>
        </div>
    )
}

export default ArrowRight
